import { BuildComponentKey } from "@common/build/types";
import { JSX_NODE_MAPPINGS } from "../jsxMapping";



export type CommonPage = {
    extraInstructions?: string;
    commonMenuIcons?: string[];
}

export type CommonPageType = keyof typeof CommonPagesToHave;


export const getPageSpecificInstructionsAndComponents = (pageType: CommonPageType) => {
   const pageInfo = CommonPagesToHave[pageType];
   const componentsForThisPage: BuildComponentKey[] = []

   Object.entries(JSX_NODE_MAPPINGS).forEach(([key, mapping]) => {
      if (mapping.typicallyUsedOnPage?.includes(pageType)) {
         componentsForThisPage.push(key as BuildComponentKey);
      }
   })
   return {
      instructions: pageInfo.extraInstructions,
      components: componentsForThisPage
   }
}


export const CommonPagesToHave= {
   "home-page": {
    extraInstructions: "The first page a user will see. Usually has the POS name, company logo, and some general dynamic data like time, outlet name etc. Image is also nice. ",
    commonMenuIcons: ["home-3"]
   },
 "product-page" : {
    extraInstructions: "That's where they should select product and be able to add it to the cart. It should have a product list, and a productSection view (with dynamic data such as product image, name, price, etc IN THE PRODUCT SECTION) to the side, with ProductQuantity and ProductVariations component, and add to cart button.",
    commonMenuIcons: ["Box-product"],
 },
 "orders-page": {
    extraInstructions: "A page that displays a single customer",
    commonMenuIcons: ["order-play"]
 }, 
 "checkout-page": {
    extraInstructions: "A page that displays the cart",
    commonMenuIcons: ["Cart v2"]
 },
 "customer-page": {
    extraInstructions: "A page that displays a single customer",
    commonMenuIcons: ["Cart v2"]
 },
 "thank-you-page": {
    extraInstructions: "A page that displays a thank you message",
 }

} as const;



export const getPageSpecificComponents = (pageType: CommonPageType) => {
   return Object.entries(JSX_NODE_MAPPINGS).filter(([_, value]) => value.typicallyUsedOnPage?.includes(pageType)).map(([key, _]) => key);
}

